// #3197 -- the scribe "Outbox" page is now the "Queue" page. The URL, the
// TopBar link and the SyncStatus chip all read this one constant so they can
// not drift apart; the legacy path stays a redirect so old bookmarks (and any
// in-flight tab from before the rename) keep working. Copy and route only:
// the IndexedDB `outbox` store and the sync code keep their names.
import { Navigate, Route } from "react-router-dom";

export const QUEUE_PATH = "/queue";
export const LEGACY_OUTBOX_PATH = "/outbox";

// Returns the Queue route plus the legacy-path redirect. A function (not a
// component) because react-router's <Routes> only accepts <Route>/fragment
// children. `queueElement` is the already-gated page (App.jsx passes
// <Scoped><Queue /></Scoped>); the Inbox section (#3198) lives on that page,
// so further Queue sub-routes get added here.
export function queueRoutes(queueElement) {
  return (
    <>
      <Route path={QUEUE_PATH} element={queueElement} />
      <Route path={LEGACY_OUTBOX_PATH} element={<Navigate to={QUEUE_PATH} replace />} />
    </>
  );
}
